export const taskStatusToColor = (status: string) => {
  switch (status) {
    case 'PENDING':
      return '#bf00ff';
    case 'REOPENED':
      return '#F33A6A';
    case 'BLOCKED':
      return '#D22B2B';
    case 'SCHEDULED':
      return '#00FFFF';
    case 'WAITING':
      return '#FFA500';
    case 'ON HOLD':
      return '#FF5F1F';
    case 'IN PROGRESS':
      return '#00bfff';
    case 'REVIEW':
      return '#FFC000';
    case 'APPROVED':
      return '#228B22';
    case 'REJECTED':
      return '#B80F0A';
    case 'COMPLETED':
      return '#228B22';
    case 'CANCELED':
      return '#71797E';
    default:
      return '#eeeeee';
  }
};
